module.exports = __webpack_public_path__ + "static/media/jd-logo.6d2d39ad.png";